import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import DashboardDrawer from './Navigation/Drawer';
import DashboardTheme from './Theme';
import TopAppBar from './Navigation/TopAppBar';
import { NavigationBarIcon } from '../Navigation';
import breakpoints from '../Theme/breakpoints';

export const DashboardWrapper = styled.div<Theme>`
  min-height: 100vh;
  background-color: ${(properties) => properties.theme.layoutBackgroundColor};
`;

export const DashboardContent = styled.div<{
  open: boolean;
  paddingDesktop?: string;
  paddingMobile?: string;
  mobileWidth?: string;
}>`
  width: ${
  ({ mobileWidth }) => (mobileWidth ?? 'calc(100vw - (102px + 1px))')
};
  padding: ${
  ({ paddingMobile }) => (paddingMobile ?? '92px 32px 0 85px')
};
  @media (min-width: ${breakpoints.sm}px) {
    width: calc(100vw - (140px + 1px));
    padding: ${
  ({ paddingDesktop }) => (paddingDesktop ?? '92px 32px 0 93px')
};
  }
`;

const StyledDrawerItems = styled.div`
  .MuiCollapse-wrapperInner {
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

const dashboardNavigationProperties = {
  children: PropTypes.node,
  navigationItems: PropTypes.node.isRequired,
  userTab: PropTypes.node,
  open: PropTypes.bool.isRequired,
  onToggleDrawer: PropTypes.func.isRequired,
  paddingDesktop: PropTypes.string,
  paddingMobile: PropTypes.string,
  mobileWidth: PropTypes.string,
  logo: PropTypes.node.isRequired,
};

type DashboardNavigationProperties = InferProps<
typeof dashboardNavigationProperties
> & {
  paddingDesktop?: string;
  paddingMobile?: string;
  mobileWidth?: string;
};

export const DashboardNavigation = ({
  open,
  onToggleDrawer,
  children,
  navigationItems,
  userTab,
  paddingDesktop,
  paddingMobile,
  mobileWidth,
  logo,
}: DashboardNavigationProperties) => (
  <>
    <TopAppBar
      open={open}
      onToggleDrawer={onToggleDrawer}
      logo={logo}
      userTab={(
        <NavigationBarIcon>
          { userTab }
        </NavigationBarIcon>
      )}
    />
    <DashboardWrapper>
      <DashboardDrawer
        open={open}
        onToggleDrawer={onToggleDrawer}
      >
        <StyledDrawerItems>
          {navigationItems}
        </StyledDrawerItems>
      </DashboardDrawer>
      <DashboardContent
        open={open}
        paddingDesktop={paddingDesktop}
        paddingMobile={paddingMobile}
        mobileWidth={mobileWidth}
      >
        { children }
      </DashboardContent>
    </DashboardWrapper>
  </>
);

const dashboardLayoutProperties = {
  onToggleDrawer: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  children: PropTypes.node,
  navigationItems: PropTypes.node.isRequired,
  userTab: PropTypes.node,
  paddingDesktop: PropTypes.string,
  paddingMobile: PropTypes.string,
  mobileWidth: PropTypes.string,
  logo: PropTypes.node.isRequired,
};

type DashboardLayoutProperties = InferProps<
  typeof dashboardLayoutProperties
> & {
  paddingDesktop?: string;
  paddingMobile?: string;
  mobileWidth?: string;
};

const DashboardLayout = ({
  open,
  onToggleDrawer,
  children,
  navigationItems,
  userTab,
  paddingDesktop,
  paddingMobile,
  mobileWidth,
  logo,
}: DashboardLayoutProperties) => (
  <DashboardTheme>
    <DashboardNavigation
      navigationItems={navigationItems}
      userTab={userTab}
      open={open}
      onToggleDrawer={onToggleDrawer}
      paddingDesktop={paddingDesktop}
      paddingMobile={paddingMobile}
      mobileWidth={mobileWidth}
      logo={logo}
    >
      { children }
    </DashboardNavigation>
  </DashboardTheme>
);

DashboardLayout.propTypes = dashboardLayoutProperties;

export default DashboardLayout;
